import { render, staticRenderFns } from "./FooterNavigation.vue?vue&type=template&id=353ea38a&"
import script from "./FooterNavigation.vue?vue&type=script&lang=js&"
export * from "./FooterNavigation.vue?vue&type=script&lang=js&"
import style0 from "./FooterNavigation.vue?vue&type=style&index=0&id=353ea38a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports